import React from "react";
import { Box, Skeleton } from "@mui/material";
import { sectionBorderColor } from "@common/components/dotLegalSection/DotLegalSection";

export interface IDashboardInnerBoxProps {
    marginTop?: number;
    fullHeight?: boolean;
    isLoading?: boolean;
    children: React.ReactNode;
    height?: number;
    paddingX?: number;
    // The widget around the box is white too, so only a border sets the box apart from it
    bordered?: boolean;
}

function DashboardInnerBox(props: IDashboardInnerBoxProps) {
    // No background of its own: the white widget shows through, and the skeleton keeps its grey so loading is visible
    const sx = {
        mt: props.marginTop,
        height: props.fullHeight ? "100%" : props.height ? props.height : undefined,
        paddingY: 2,
        paddingX: props.paddingX ?? 2,
        borderRadius: "20px",
        border: props.bordered ? `1px solid ${sectionBorderColor}` : undefined,
    };
    return <>{props.isLoading ? <Skeleton sx={sx} variant={"rectangular"} /> : <Box sx={sx}>{props.children}</Box>}</>;
}

export default DashboardInnerBox;
